/**
 * Mixpanel Event Tracking Configuration Array
 *
 * FORMAT:
 *   {
 *      key: "event-key",
 *      eventName: "Event Name",
 *      eventHasParameters: true,
 *      needsAPIData: true,
 *      needsElementData: true,
 *      needsConstData: true,
 *      needsNativeCodeData: true,
 *      apiUrl: "api-url",
 *      apiDataMap: {},
 *      elementDataMap: {},
 *      constDataMap: {},
 *      customFunction: false
 *   }
 *
 * FORMAT FIELDS EXAPAINATION:
 *   key: "Key of the event which is the value that we put in the value of the attribute 'data-vego-event'.",
 *   eventName: "Event Name that will showed in the mixpanel dashboard.",
 *   eventHasParameters: "flag to check if the event has parameters or not, if this is false, then all type of parameter flags are false for this event ( needsAPIData, needsElementData, needsConstData, needsNativeCodeData ).",
 *   needsAPIData: "flag to check if the event needs api data or not ( this is to decide whether we need to make an AJAX call or not ).",
 *   needsElementData: "flag to check if the event needs element data or not ( this is to decide whether we need to fetch data from other attributes of the element or not ).",
 *   needsConstData: "flag to check if the event needs const data or not ( this is to decide whether we need any constant data or not ).",
 *   needsNativeCodeData: "this is to decide whether we need any native code ( that we fetch from the liquid code directly and pass it as attribute with a predefined pre-name of 'vego-event-attr-' and afte this dash we will put the actual name of the attribute that we want to have in mixpanel event properties and the value will be the value against this attribute ).",
 *   apiDataMap: if the needsAPIData flag is true, then this will contain the data that we use to map the api response to the response needed to send to the event.
 *   apiUrl: if the needsAPIData flag is true, then this will contain the api url to make the AJAX call.
 *   elementDataMap: if the needsElementData flag is true, then this will contain the data that we use to map the element data to the response needed to send to the event.
 *   constDataMap: if the needsConstData flag is true, then this will contain the actual constant data to send to the event.
 *   customFunction: this is the flag, that we need if any event does not fall under this dynamic configuration and needs it custom way in any part, like in different api response mapping, different api call, different element after fetching the main one, and so on. ( this flag is there to just keep the functionality running till we found the way to fit this in the dynamic structure too ).
 */
 const eventConfig = [
    {
      key: "shop-now-button-clicked",
      eventName: "Shop Now Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "terms-button-clicked",
      eventName: "Terms Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "shop-all-button-clicked",
      eventName: "Shop All Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "help-me-choose-clicked",
      eventName: "Help Me Choose Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "build-your-own-button-clicked",
      eventName: "Build Your Own Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "grow-with-us-button-clicked",
      eventName: "Grow With Us Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "about-us-button-clicked",
      eventName: "About Us Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "best-seller-button-clicked",
      eventName: "New Arrivals Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "new-arrivals-button-clicked",
      eventName: "New Arrivals Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "on-sale-button-clicked",
      eventName: "On Sale Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "add-to-cart-clicked",
      eventName: "Add To Cart Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {
        productName: "handle",
        productUrl: "url",
        productPrice: "price",
        category: "product_type",
        varientSku: "sku",
        // "tags": "tags",
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: true,
    },
    {
      key: "cart-button-clicked",
      eventName: "Cart Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "remove-from-cart-clicked",
      eventName: "Remove From Cart Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {
        productName: "handle",
        productUrl: "url",
        productPrice: "price",
        category: "product_type",
        varientSku: "sku",
        // "tags": "tags",
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: true,
    },
    {
      key: "add-to-cart-frequently-paired-with-clicked",
      eventName: "Add To Cart From Frequently Paired With Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {
        productName: "handle",
        productUrl: "url",
        productPrice: "price",
        category: "product_type",
        varientSku: "sku",
        // "tags": "tags",
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: true,
    },
    {
      key: "add-to-cart-the-perfect-pair-clicked",
      eventName: "Add To Cart From Perfect Pair Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {
        productName: "handle",
        productUrl: "url",
        productPrice: "price",
        category: "product_type",
        varientSku: "sku",
        // "tags": "tags",
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: true,
    },
    {
      key: "checkout-button-clicked",
      eventName: "Checkout Button Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiUrl: "https://vegogarden.com/cart.json",
      apiDataMap: {
        itemCount: "item_count",
        itemsSubtotalPrice: "items_subtotal_price",
        originalTotalPrice: "original_total_price",
        totalDiscount: "total_discount",
        totalPrice: "total_price",
        totalWeight: "total_weight"
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "main-header-button-clicked",
      eventName: "Main Header Collection Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "main-header-drop-down-item-clicked",
      eventName: "Main Header Drop Down Item Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "footer-support-section-clicked",
      eventName: "Footer Support Section Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        visitedPageUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "main-header-drop-down-item-contact-info-clicked",
      eventName: "Main Header Drop Down item contact info Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "vego-garden-logo-clicked",
      eventName: "Logo Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "announcement-link-clicked",
      eventName: "Announcement Bar Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "user-searched-something",
      eventName: "User Searched Something",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "login-button-clicked",
      eventName: "Login Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "giving-back-page-visited",
      eventName: "Giving Back Page Visited",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        pageName: "Giving Back Page Visited",
        source: source,
      },
      customFunction: false,
    },
    {
      key: "affiliate-program-page-visited",
      eventName: "Affiliate Program Page Visited",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        pageName: "Affiliate Program Page Visited",
        source: source,
      },
      customFunction: false,
    },
    {
      key: "kids-program-page-visited",
      eventName: "#VegoGardenKindsProgram Page Visited",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        pageName: "Kids Program Page Visited",
        source: source,
      },
      customFunction: false,
    },
    {
      key: "more-about-vz2-0-button-clicked",
      eventName: "More About VZ2.0 Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        pageName: "More About VZ2.0 ( feature material page )",
        source: source,
      },
      customFunction: false,
    },
    {
      key: "our-trusted-retailers-section-element-clicked",
      eventName: "Retailers Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "social-link-clicked",
      eventName: "Social Link Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {
        pageUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "dirty-hand-blog-clicked",
      eventName: "Get Your Hands Dirty - Blog Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        blogHandle: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "dirty-hand-blog-tag-clicked",
      eventName: "Get Your Hands Dirty - Blog Tag Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        blogHandleWithSelectedTag: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-section-clicked",
      eventName: "Collection Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        collectionUrl: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "view-all-collection-items-clicked",
      eventName: "View All Collection Items Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: true,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {
        collectionURL: "href",
      },
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "product-clicked",
      eventName: "Product Clicked",
      eventHasParameters: true,
      needsAPIData: true,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {
        productTitle: "title",
        productName: "handle",
        productUrl: "url",
        productPrice: "price",
        category: "product_type",
        varientSku: "sku",
        // "tags": "tags",
      },
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: true,
    },
    {
      key: "information-section-clicked",
      eventName: "Information Section Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-filter-dropdown-clicked",
      eventName: "Collection Filter Dropdown Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-filter-from-dropdown-selected",
      eventName: "Collection Filter From Dropdown Selected",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-filter-drawer-clicked",
      eventName: "Collection Filter Drawer Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-filter-drawer-category-clicked",
      eventName: "Collection Filter Drawer Category Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-filter-drawer-sub-category-selected",
      eventName: "Collection Filter Drawer Sub Category Selected",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "collection-promotion-banner-clicked",
      eventName: "Collection Promotion Banner Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "subscribe-button-clicked",
      eventName: "Subscribe Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "begin-planning-button-clicked",
      eventName: "Begin Planning Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "faq-section-viewed",
      eventName: "FAQ Section Viewed",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "faq-section-via-category-viewed",
      eventName: "FAQ Section Via Category Viewed",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "page-visited",
      eventName: "Page Visited",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "blog-visited",
      eventName: "Blog Visited",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "menu-testing-click",
      eventName: "Menu AB Testing Click",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "vego-logo-click",
      eventName: "Vego Logo Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "cart-button-clicked",
      eventName: "Cart Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "login-button-click",
      eventName: "Login Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "menu-button-clicked",
      eventName: "Menu Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: true,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    },
    {
      key: "search-button-clicked",
      eventName: "Search Button Clicked",
      eventHasParameters: true,
      needsAPIData: false,
      needsElementData: false,
      needsConstData: true,
      needsNativeCodeData: false,
      apiDataMap: {},
      elementDataMap: {},
      constDataMap: {
        source: source,
      },
      customFunction: false,
    }
  ];

  /**
   * Observation configuration for Lazy-loaded components
   * 
   * DESCRIPTION:
   * As we have some lazily loaded components which either gets added from script or api call after DOM is loaded,
   * and for adding event tracking to them, we have used "MutationObserver" to observe the direct parent of the dynamically loaded component, and this parent should be there when DOM loads, no matter if its empty.
   * and this configuration is for that parent element fetching, means any 'querySelector' supported query that uniquly identifies the parent component in the DOM
   * 
   */
  const observationConfig = [
    {
      parentElementQuery: "#CartDrawer",
    },
    {
      parentElementQuery: ".product-recommend-section",
    },
    // {
    //   parentElementQuery: ".yotpo-widget-instance"
    // }
  ];